module.exports = __webpack_public_path__ + "img/giz.5bd40b37.png";